import { DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, Inject, OnInit, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { EnvironmentModel } from '../environments/environment.model'

@Component({
  selector: 'galabid-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'gb-dashboard'

  constructor(
    @Inject(APP_CONFIG) private appConfig: EnvironmentModel,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) protected platformId: object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.updateFaviconHref('favicon', 'favicon-32x32.png')
      this.updateFaviconHref('android-icon', 'android-icon-192x192.png')
      this.updateFaviconHref('apple-icon', 'apple-icon-180x180.png')
    }
  }

  private updateFaviconHref(id: string, filename: string): void {
    const element = this.document.getElementById(id) as HTMLLinkElement
    if (element) element.href = `${this.appConfig.sharedStaticUrl}images/favicon/${filename}`
  }
}
